import { defineMessages } from 'react-intl'

const scope = `procurify.components.OrderItemTypeTag`

export default defineMessages({
  isBlanketOrderItem: {
    id: `${scope}.isBlanketOrderItem`,
    defaultMessage: 'Blanket order item',
  },
  isRecurringOrderItem: {
    id: `${scope}.recurring`,
    defaultMessage: 'Recurring',
  },
})
